import React from 'react'
import { Flex, Progress } from 'antd'

const StatisticsWithProgress = ({
    label,
    steps = 8,
    current = '...',
    total = '...',
    size = 'small',
    align = 'center',
    justify = 'center',
    style,
    title,
}) => {
    const percent = (current / total) * 100

    return (
        <Flex vertical align={align} justify={justify} style={style} title={title}>
            {label}
            <Progress percent={percent} steps={steps} format={() => `${current}/${total}`} size={size} />
        </Flex>
    )
}

export default StatisticsWithProgress
